/* free-shipping-bar-sync.js
   Mantiene sincronizada la barra de envio gratis (snippets/free-shipping-bar.liquid)
   y el bloque cart-topup tras cambios de carrito por AJAX (anadir, cambiar cantidad,
   eliminar), sin recargar la pagina. No crea ninguna barra nueva: solo actualiza el
   texto y el progreso del bloque que ya renderiza Liquid en la carga inicial
   ([data-free-shipping-bar]). Cowork, 27/07/2026.
   Umbral debe coincidir siempre con snippets/free-shipping-bar.liquid y
   snippets/cart-topup.liquid (free_shipping_threshold = 3900). */
(function () {
  var THRESHOLD = 3900;

  function money(cents) {
    var v = (cents / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return '€' + v;
  }

  function render(total) {
    var bar = document.querySelector('[data-free-shipping-bar]');
    if (bar) {
      var remaining = THRESHOLD - total;
      var progress = Math.min(100, Math.round((total / THRESHOLD) * 100));
      var msgEl = bar.querySelector('.m-free-shipping-bar__message');
      var fillEl = bar.querySelector('.m-free-shipping-bar__fill');
      var trackEl = bar.querySelector('.m-free-shipping-bar__track');
      if (msgEl) {
        if (remaining <= 0) {
          msgEl.className = 'm-free-shipping-bar__message m-free-shipping-bar__message--success';
          msgEl.innerHTML = '<span aria-hidden="true">&#10003;</span> ¡Enhorabuena! Tienes envío <strong>GRATIS</strong> en este pedido';
        } else {
          msgEl.className = 'm-free-shipping-bar__message';
          msgEl.innerHTML = 'Te faltan <strong>' + money(remaining) + '</strong> para conseguir el <strong>envío GRATIS</strong> 🚚';
        }
      }
      if (fillEl) fillEl.style.width = progress + '%';
      if (trackEl) trackEl.setAttribute('aria-valuenow', progress);
    }

    // Oculta la sugerencia "completa tu pedido" en cuanto se alcanza el envio gratis
    var topup = document.querySelector('[data-cart-topup]');
    if (topup) topup.style.display = (THRESHOLD - total) <= 0 ? 'none' : '';
  }

  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart.total_price); })
      .catch(function () {});
  }

  // 1) Evento nativo de Minimog tras cambios de cantidad/eliminacion en el carrito
  document.addEventListener('cart:updated', refresh);

  // 2) Cualquier peticion a rutas de carrito (anadir, cambiar, actualizar, vaciar),
  //    cubre botones de anadir rapido (cart-topup, quick add) que no siempre
  //    disparan el evento anterior.
  var _fetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    return _fetch.apply(this, args).then(function (res) {
      try {
        var url = (args[0] && args[0].url) || args[0] || '';
        if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
          setTimeout(refresh, 250);
        }
      } catch (e) {}
      return res;
    });
  };
})();
